import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=00163341&scoped=true&"
import script from "./TrendChart.vue?vue&type=script&lang=js&"
export * from "./TrendChart.vue?vue&type=script&lang=js&"
import style0 from "./TrendChart.vue?vue&type=style&index=0&id=00163341&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00163341",
  null
  
)

export default component.exports